import React, { Component } from 'react'
import { connect } from 'react-redux'
import { lang } from '../../strings'
import SubscriptionsList from './subscriptions-list'
import SubscriptionDetails from './subscription-details'
import NetworkServices from './network-services'
import SimCard from './sim-card'
import DataPackage from './data-package'
import BarSubscription from './bar-subscription'
import { trackEvent, SUBSCRIPTION, LOAD } from '../../utils/analytics'
import {
  getSubscriptions,
  getSubscriptionIfExists,
  orderSimCard,
  orderExtraSimCard,
  activateSimCard,
  orderTopUp,
  orderDataPackageChange,
  changeNetworkService,
  changeBarService,
} from './actions'

import { getCustomer } from '../customer/actions'

class Subscriptions extends Component {
  componentWillMount() {
    const { dispatch, subscriptions, customer } = this.props

    if (subscriptions.isEmpty()) {
      dispatch(getSubscriptions())
    }

    if (customer.isEmpty()) {
      dispatch(getCustomer())
    }
  }

  componentDidMount() {
    trackEvent(SUBSCRIPTION, LOAD)
  }

  render() {
    let { appState, subscriptions } = this.props
    let { networkProgress } = appState.toJS()

    if (subscriptions.isEmpty() && networkProgress) {
      return this.renderLoading()
    }

    if (!subscriptions.isEmpty() && subscriptions.count() === 0) {
      return this.renderNoSubscriptions()
    }

    return this.renderSubscriptions()
  }

  renderSubscriptions() {
    let { subscriptions, subscription, customer } = this.props
    let {
      simCardInfo,
      networkServices,
      dataPackages,
      dataCapStatus,
      tasks,
      barServices,
      dataPackageName,
      hasDataPackage,
      netType,
    } = subscription.toJS()

    let simCardTasks
    let extraSimCardTasks
    let subscriptionTerminationTasks
    let dataPackageChangeTasks
    let subscriptionConversionTasks
    let subscriptionNumberChangeTasks
    let subscriptionTransferTasks

    const customerType = customer.toJS().customerType

    if (tasks) {
      simCardTasks = tasks.filter(task => {
        return task.type === Subscriptions.taskTypes.simCardExchange
      })
      extraSimCardTasks = tasks.filter(task => {
        return task.type === Subscriptions.taskTypes.sharedDataRegistration
      })
      subscriptionConversionTasks = tasks.filter(task => {
        return task.type === Subscriptions.taskTypes.subscriptionConversion
      })
      dataPackageChangeTasks = tasks.filter(task => {
        return task.type === Subscriptions.taskTypes.dataPackageChange
      })
      subscriptionTerminationTasks = tasks.filter(task => {
        return task.type === Subscriptions.taskTypes.subscriptionTermination
      })
      subscriptionNumberChangeTasks = tasks.filter(task => {
        return task.type === Subscriptions.taskTypes.subscriptionNumberChange
      })
      subscriptionTransferTasks = tasks.filter(task => {
        return task.type === Subscriptions.taskTypes.subscriptionTransfer
      })
    }

    return (
      <div>
        <SubscriptionsList
          subscriptions={subscriptions.toJS()}
          subscription={subscription.toJS()}
          subscriptionSelected={this.getSubscription}
        />
        {!subscription.isEmpty() ? (
          <SubscriptionDetails
            subscription={subscription.toJS()}
            conversionTasks={subscriptionConversionTasks}
            terminationTasks={subscriptionTerminationTasks}
            numberChangeTasks={subscriptionNumberChangeTasks}
            transferTasks={subscriptionTransferTasks}
          />
        ) : null}
        <br />
        <div className='mp-block'>
          <div className='mp-block-half'>
            {dataPackages ? (
              <DataPackage
                dataCapStatus={dataCapStatus}
                dataPackageName={dataPackageName}
                orderTopUp={this.orderTopUp}
                changeDataPackage={this.changeDataPackage}
                dataPackages={dataPackages}
                dataPackageTasks={dataPackageChangeTasks}
                netType={netType}
                hasDataPackage={hasDataPackage}
              />
            ) : null}
          </div>
          <div className='mp-block-half'>
            {simCardInfo ? (
              <SimCard
                simCardInfo={simCardInfo}
                orderSimCard={this.orderSimCard}
                orderExtraSimCard={this.orderExtraSimCard}
                activateSimCard={this.activateSimCard}
                simCardTasks={simCardTasks}
                extraSimCardTasks={extraSimCardTasks}
                customerType={customerType}
              />
            ) : null}
          </div>
        </div>
        <div className='mp-block'>
          <div className='mp-block-half'>
            {networkServices ? (
              <NetworkServices
                networkServices={networkServices}
                changeNetworkService={this.changeNetworkService}
              />
            ) : null}
          </div>
          <div className='mp-block-half'>
            {barServices ? (
              <BarSubscription
                services={barServices}
                changeBarService={this.changeBarService}
              />
            ) : null}
          </div>
        </div>
        <p className='mp-small mp-right'>
          {lang.subscription[`vatInfo${customerType}`]}
        </p>
      </div>
    )
  }

  renderLoading() {
    return (
      <div>
        <h2>{lang.subscription.title}</h2>
        <p>{lang.subscription.loading}</p>
      </div>
    )
  }

  renderNoSubscriptions() {
    return (
      <div>
        <h2>{lang.subscription.title}</h2>
        <p className='mp-info'>{lang.subscription.noActiveSubscriptions}</p>
      </div>
    )
  }

  changeBarService = service => {
    const { dispatch, subscription } = this.props
    let { id } = subscription.toJS()
    dispatch(changeBarService(id, service.id, service.enabled))
  }

  getSubscription = subscriptionId => {
    const { dispatch, subscriptions } = this.props
    let subscription = subscriptions.find(s => {
      return s.get('id') == subscriptionId
    })

    if (subscription) {
      dispatch(getSubscriptionIfExists(subscription.toJS()))
    }
  }

  orderSimCard = activationTime => {
    const { dispatch, subscription } = this.props
    let { id } = subscription.toJS()
    dispatch(orderSimCard(id, activationTime))
  }

  orderExtraSimCard = activationTime => {
    const { dispatch, subscription } = this.props
    let { id } = subscription.toJS()
    dispatch(orderExtraSimCard(id, activationTime))
  }

  activateSimCard = () => {
    const { dispatch, subscription } = this.props
    let { id } = subscription.toJS()
    dispatch(activateSimCard(id))
  }

  changeDataPackage = data => {
    const { dispatch, subscription } = this.props
    let { id } = subscription.toJS()
    dispatch(orderDataPackageChange(id, data))
  }

  orderTopUp = data => {
    const { dispatch, subscription } = this.props
    let { id } = subscription.toJS()
    dispatch(orderTopUp(id, data))
  }

  changeNetworkService = service => {
    const { dispatch, subscription } = this.props
    let { id } = subscription.toJS()
    dispatch(changeNetworkService(id, service.id, service.enabled))
  }
}

function propProvider(reduxState) {
  const { appState, subscriptions, subscription, customer } = reduxState

  return {
    appState,
    subscriptions,
    subscription,
    customer,
  }
}

Subscriptions.taskTypes = {
  simCardExchange: 2,
  dataPackageChange: 3,
  subscriptionConversion: 4,
  subscriptionTransfer: 5,
  subscriptionTermination: 6,
  subscriptionNumberChange: 7,
  sharedDataRegistration: 8,
}

export default connect(propProvider)(Subscriptions)
